import React from "react";
import "../styles/CollectionFilters.css";

interface CollectionFiltersProps {
  selectedDifficulty: string;
  onDifficultyChange: (difficulty: string) => void;
  selectedCompany: string;
  onCompanyChange: (company: string) => void;
  selectedPattern: string;
  onPatternChange: (pattern: string) => void;
  selectedStatus: string;
  onStatusChange: (status: string) => void;
  availableCompanies: string[];
  availablePatterns: string[];
  onClearFilters: () => void;
}

export const CollectionFilters: React.FC<CollectionFiltersProps> = ({
  selectedDifficulty,
  onDifficultyChange,
  selectedCompany,
  onCompanyChange,
  selectedPattern,
  onPatternChange,
  selectedStatus,
  onStatusChange,
  availableCompanies,
  availablePatterns,
  onClearFilters,
}) => {
  const hasActiveFilters =
    selectedDifficulty !== "" ||
    selectedCompany !== "" ||
    selectedPattern !== "" ||
    selectedStatus !== "";

  return (
    <div className="collection-filters">
      <select
        className="filter-select"
        value={selectedDifficulty}
        onChange={(e) => onDifficultyChange(e.target.value)}
      >
        <option value="">All Difficulties</option>
        <option value="Easy">Easy</option>
        <option value="Medium">Medium</option>
        <option value="Hard">Hard</option>
      </select>

      <select
        className="filter-select"
        value={selectedCompany}
        onChange={(e) => onCompanyChange(e.target.value)}
      >
        <option value="">All Companies</option>
        {[...availableCompanies].sort().map((company) => (
          <option key={company} value={company}>
            {company}
          </option>
        ))}
      </select>

      <select
        className="filter-select"
        value={selectedPattern}
        onChange={(e) => onPatternChange(e.target.value)}
      >
        <option value="">All Patterns</option>
        {[...availablePatterns].sort().map((pattern) => (
          <option key={pattern} value={pattern}>
            {pattern}
          </option>
        ))}
      </select>

      <select
        className="filter-select"
        value={selectedStatus}
        onChange={(e) => onStatusChange(e.target.value)}
      >
        <option value="">All Status</option>
        <option value="checked">Checked</option>
        <option value="unchecked">Unchecked</option>
      </select>

      {hasActiveFilters && (
        <button className="clear-filters-btn" onClick={onClearFilters}>
          Clear Filters
        </button>
      )}
    </div>
  );
};
